

















/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { OGCLayer } from '@/models/RemoteServer';
import Component from 'vue-class-component';
import BaseComponent from '../../BaseComponent';

@Component({
  name: 'CatalogSearchResult',
  props: {
    layer: {},
    layerType: String,
    selectedLayerList: {},
    selectedStyle: {},
  },
})
export default class CatalogSearchResult extends BaseComponent {
  layer!:any;

  layerType!:string;

  selectedLayerList !:any;

  selectedStyle !:any;

  layerGroup = false;

  hasMultipleStyle = false;

  hasSubLayers = false;

  showSubLayers = true;

  toggle() :void {
    this.showSubLayers = !this.showSubLayers;
  }

  isSelected(result:OGCLayer): boolean {
    if (this.selectedLayerList.length === 0) {
      return false;
    }
    return this.selectedLayerList.find((x:OGCLayer) => x.Title === result.Title) !== undefined;
  }

  mounted() {
    console.log(this.layer);
  }

  selectLayer(layer:any) :void{
    console.log(this.layer);
    this.$emit('selectLayer', layer);
  }
}

